import script from "./DefaultItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__